import ky from 'ky'
import ActivityBasedTimer from '@/services/activityBasedTimer'
import store from '@/store'
import { LOCAL_STORAGE_KEYS } from '@/constants'

const versionTimer = ActivityBasedTimer()

export const isNewerVersionAvailable = () => ky.get('/hash.txt')
  .then(res => res.text())
  .then(hash => {
    if (!hash) {
      return false
    }

    const lsHash = localStorage.getItem(LOCAL_STORAGE_KEYS.HASH)

    localStorage.setItem(LOCAL_STORAGE_KEYS.HASH, hash)

    if (!lsHash) {
      return false
    }

    return hash !== lsHash
  })
  .catch(e => false)

versionTimer.setInterval({
  async callback () {
    const newVersionAvailable = await isNewerVersionAvailable()

    if (!newVersionAvailable) {
      return
    }

    store.commit('app/SET_NEW_VERSION_AVAILABLE', true)
  },
  // Normal interval is once every 10 minutes
  // interval: 1000 * 60 * 10,
  interval: 1000 * 10,
  // Forced interval is once per day
  forcedInterval: 1000 * 60 * 60 * 24
})

export default versionTimer
